module.exports = __webpack_public_path__ + "assets/growth-38e6935705e975e7b413dc22f38a6c39.svg";